<template>
  <div class="hkl-card row">
    <HKLCardHeader class="small-12">
      <slot name="header">
        {{ title }}
      </slot>
    </HKLCardHeader>
    <HKLCardBody class="small-12">
      <slot />
    </HKLCardBody>
  </div>
</template>

<script>
import HKLCardHeader from './HKLCardHeader.vue'
import HKLCardBody from './HKLCardBody.vue'

export default {
  components: {
    HKLCardHeader,
    HKLCardBody,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.hkl-card {
  align-content: flex-start;
}
.hkl-card_header {
  z-index: 1;
}
</style>
